(() => {
  const calm = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const cfg = window.Cartex || { moneyFormat: "€{{amount}}", routes: { cartAdd: "/cart/add.js", cartChange: "/cart/change.js", cart: "/cart.js" } };

  // Shopify money format, e.g. "€{{amount}}" or "{{amount_with_comma_separator}} €"
  function money(cents) {
    const n = (cents || 0) / 100;
    const fmt = (v, dec, th, d) => {
      const [i, f] = v.toFixed(dec).split(".");
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? d + f : "");
    };
    return cfg.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fmt(n, 2, ",", "."),
      amount_no_decimals: fmt(n, 0, ",", "."),
      amount_with_comma_separator: fmt(n, 2, ".", ","),
      amount_no_decimals_with_comma_separator: fmt(n, 0, ".", ","),
      amount_with_apostrophe_separator: fmt(n, 2, "'", ".")
    }[k] || fmt(n, 2, ",", ".")));
  }
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

  let toastTimer;
  function toast(msg) {
    const t = $("#CartexToast");
    if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => (t.hidden = true), 3000);
  }

  /* ---------- Cart drawer ---------- */
  const drawer = $("#CartDrawer"), scrim = $("#CartScrim");
  function openCart() { if (!drawer) return; drawer.hidden = false; scrim.hidden = false; header && header.classList.remove("away"); $(".x", drawer).focus(); }
  function closeCart() { if (!drawer) return; drawer.hidden = true; scrim.hidden = true; }

  function renderCart(cart) {
    $$("[data-cart-count]").forEach(el => (el.textContent = cart.item_count));
    if (!drawer) return;
    const lines = $("#CartLines");
    lines.innerHTML = cart.items.length ? cart.items.map(it => `
      <div class="line">
        ${it.image ? `<img src="${esc(it.image)}&width=120" alt="" width="56" height="56">` : "<span></span>"}
        <div><a class="nm" href="${esc(it.url)}" style="text-decoration:none">${esc(it.product_title)}</a>
          <div class="meta">${it.variant_title ? esc(it.variant_title) + " · " : ""}${it.quantity} × ${money(it.final_price)}</div>
          <button class="rm" type="button" data-remove="${esc(it.key)}">Hiqe</button></div>
        <div style="font-variant-numeric:tabular-nums">${money(it.final_line_price)}</div>
      </div>`).join("") : '<p class="empty">Shporta është bosh.</p>';
    $("#CartTotal").textContent = money(cart.total_price);
    $("#CartCheckout").toggleAttribute("disabled", !cart.items.length);
  }
  const refreshCart = () => fetch(cfg.routes.cart, { headers: { Accept: "application/json" } }).then(r => r.json()).then(renderCart);

  document.addEventListener("submit", e => {
    const form = e.target;
    if (!form.matches("form[action*='/cart/add']") || !drawer) return;
    e.preventDefault();
    const btn = $("[type=submit]", form);
    btn && btn.setAttribute("aria-busy", "true");
    fetch(cfg.routes.cartAdd, { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) })
      .then(r => r.json().then(j => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        if (!ok) throw new Error(j.description || j.message || "Nuk u shtua në shportë.");
        return refreshCart().then(openCart);
      })
      .catch(err => toast(err.message))
      .finally(() => btn && btn.removeAttribute("aria-busy"));
  });

  document.addEventListener("click", e => {
    if (e.target.closest("[data-open-cart]") && drawer) { e.preventDefault(); refreshCart().finally(openCart); return; }
    if (e.target.closest("[data-close-cart]")) { closeCart(); return; }
    const rm = e.target.closest("[data-remove]");
    if (rm) {
      fetch(cfg.routes.cartChange, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: rm.dataset.remove, quantity: 0 }) })
        .then(r => r.json()).then(renderCart);
      return;
    }
    const step = e.target.closest("[data-step]");
    if (step) {
      const input = $("input", step.closest(".qty"));
      input.value = Math.max(+input.min || 1, (+input.value || 1) + +step.dataset.step);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeCart(); });

  /* ---------- Header ---------- */
  const header = $(".site-header");
  const hasHero = !!$("main > .shopify-section:first-child .hero");
  document.body.classList.toggle("has-hero", hasHero);
  function headerHeight() { if (header) document.documentElement.style.setProperty("--hh", header.offsetHeight + "px"); }
  let lastY = scrollY;
  function onScroll() {
    if (!header) return;
    const y = scrollY, top = hasHero && y < 60 && $("#MobileNav") && $("#MobileNav").hidden;
    header.classList.toggle("clear", !!top);
    document.body.classList.toggle("home-top", !!top);
    header.classList.toggle("away", !calm && y > 300 && y > lastY && (!drawer || drawer.hidden));
    lastY = y;
  }
  addEventListener("scroll", onScroll, { passive: true });
  addEventListener("resize", headerHeight);
  const menuBtn = $("#MenuBtn");
  menuBtn && menuBtn.addEventListener("click", () => {
    const nav = $("#MobileNav");
    nav.hidden = !nav.hidden;
    menuBtn.setAttribute("aria-expanded", String(!nav.hidden));
    onScroll();
  });

  /* ---------- Announcement bar ---------- */
  $$(".notice").forEach(bar => {
    const items = [...bar.children];
    if (calm || items.length < 2) return;
    let i = 0;
    setInterval(() => {
      const cur = items[i]; i = (i + 1) % items.length; const next = items[i];
      cur.classList.add("out"); cur.classList.remove("on");
      next.classList.remove("out"); next.classList.add("on");
      setTimeout(() => cur.classList.remove("out"), 650);
    }, 3800);
  });

  /* ---------- Hero: slow-motion water mist ---------- */
  $$(".hero canvas[data-mist]").forEach(cv => {
    if (calm || !cv.getContext) return;
    const ctx = cv.getContext("2d");
    let w, h, parts = [], visible = true;
    new IntersectionObserver(([en]) => (visible = en.isIntersecting)).observe(cv);
    const spawn = any => {
      const z = Math.random();
      return { x: Math.random() * w, y: any ? Math.random() * h : h + 10, r: .6 + z * z * 3.2, vy: -(.05 + z * .22), vx: .08 + z * .18, a: .12 + z * .4, t: Math.random() * 6.28 };
    };
    function size() {
      const r = Math.min(devicePixelRatio || 1, 2);
      w = cv.clientWidth; h = cv.clientHeight;
      cv.width = w * r; cv.height = h * r; ctx.setTransform(r, 0, 0, r, 0, 0);
      parts = Array.from({ length: Math.round(w * h / 9000) }, () => spawn(true));
    }
    function frame() {
      if (visible) {
        ctx.clearRect(0, 0, w, h);
        for (const p of parts) {
          p.t += .01; p.y += p.vy; p.x += p.vx + Math.sin(p.t) * .08;
          if (p.y < -10 || p.x > w + 10) Object.assign(p, spawn(false), { x: Math.random() * w * .9 });
          const g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 2.4);
          g.addColorStop(0, `rgba(255,255,255,${p.a})`); g.addColorStop(.4, `rgba(220,215,255,${p.a * .45})`); g.addColorStop(1, "rgba(255,255,255,0)");
          ctx.fillStyle = g; ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 2.4, 0, 6.283); ctx.fill();
        }
      }
      requestAnimationFrame(frame);
    }
    size(); addEventListener("resize", size); frame();
  });

  /* ---------- Parallax wallpaper bands ---------- */
  const bands = $$(".band .bg");
  if (!calm && bands.length) addEventListener("scroll", () => {
    bands.forEach(img => {
      const r = img.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      img.style.transform = `translate3d(0, ${((r.top + r.height / 2 - innerHeight / 2) / innerHeight) * -40}px, 0)`;
    });
  }, { passive: true });

  /* ---------- Count-up and scroll reveal ---------- */
  function count(el) {
    if (calm || el.dataset.done) return;
    const m = el.textContent.trim().match(/^(\d+)(.*)$/);
    if (!m) return;
    el.dataset.done = 1;
    const end = +m[1], suf = m[2], t0 = performance.now();
    (function tick(t) {
      const k = Math.min((t - t0) / 1400, 1);
      el.textContent = Math.round(end * (1 - Math.pow(1 - k, 3))) + suf;
      if (k < 1) requestAnimationFrame(tick);
    })(t0);
  }
  const io = "IntersectionObserver" in window && new IntersectionObserver(entries => entries.forEach(en => {
    if (!en.isIntersecting) return;
    en.target.classList.add("reveal-in"); en.target.classList.remove("reveal-wait");
    io.unobserve(en.target);
    $$("[data-count]", en.target).forEach(count);
  }), { rootMargin: "0px 0px -8% 0px" });
  function setupReveal() {
    if (calm || !io) return;
    $$(".head, .cards .card, .feature, .choose > div, .soon-box, .band .content > *, .facts > div, .compare > *, .care li, .faq details").forEach(el => {
      if (el.dataset.rv) return;
      el.dataset.rv = 1;
      el.style.setProperty("--d", Math.min([...el.parentElement.children].indexOf(el), 6) * 0.08 + "s");
      const r = el.getBoundingClientRect();
      if (r.top < innerHeight && r.bottom > 0) { $$("[data-count]", el).forEach(count); return; }
      el.classList.add("reveal-wait");
      io.observe(el);
    });
  }

  /* ---------- Product page ---------- */
  $$("[data-product]").forEach(root => {
    const main = $(".main-img", root);
    $$(".thumbs button", root).forEach(b => b.addEventListener("click", () => {
      main.src = b.dataset.src; main.removeAttribute("srcset");
      $$(".thumbs button", root).forEach(x => x.setAttribute("aria-pressed", x === b));
    }));

    const json = $("[data-variants]", root);
    const select = $("select[name='id']", root);
    if (json && select) {
      const variants = JSON.parse(json.textContent);
      select.addEventListener("change", () => {
        const v = variants.find(x => String(x.id) === select.value);
        if (!v) return;
        const sale = v.compare_at_price > v.price;
        $$("[data-price]").forEach(el => { el.textContent = money(v.price); el.classList.toggle("sale", sale); });
        $$("[data-was]").forEach(el => { el.textContent = sale ? money(v.compare_at_price) : ""; });
        const add = $("[data-add-btn]", root);
        add.disabled = !v.available;
        add.textContent = v.available ? "Shto në shportë" : "E shitur";
        if (v.featured_image && main) { main.src = v.featured_image.src; main.removeAttribute("srcset"); }
      });
    }

    const sticky = $("[data-sticky-buy]");
    const addBtn = $("[data-add-btn]", root);
    if (sticky && addBtn && "IntersectionObserver" in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle("show", !en.isIntersecting && en.boundingClientRect.top < 0)).observe(addBtn);
      $("button", sticky).addEventListener("click", () => {
        const form = addBtn.closest("form");
        form.requestSubmit ? form.requestSubmit(addBtn) : addBtn.click();
      });
    }
  });

  /* ---------- Cart page quantity auto-update ---------- */
  $$("form[data-cart-page] .qty input").forEach(i => i.addEventListener("change", () => i.form.submit()));

  function boot() { headerHeight(); onScroll(); setupReveal(); }
  if (document.readyState === "complete") boot(); else addEventListener("load", boot);
  headerHeight();
})();
